'use client'
import { DirectionProvider } from '@radix-ui/react-direction'
import { Fragment } from 'react'
import { Toaster } from 'sonner'

import ScrollToTop from './ScrollToTop'

type ProvidersProps = {
  children: React.ReactNode
  dir: 'ltr' | 'rtl'
}

const Providers = ({ children, dir }: ProvidersProps) => {
  return (
    <Fragment>
      <Toaster
        closeButton
        richColors
        expand
        position='top-center'
        toastOptions={{
          classNames: {
            title: 'text-lg',
            icon: 'size-12',
          },
        }}
      />
      <ScrollToTop />
      <DirectionProvider dir={dir}>{children}</DirectionProvider>
    </Fragment>
  )
}

export default Providers
